<template>
  <div>
    <b-card no-body class="mb-1">
      <b-card-body class="py-1">
        <b-row>
          <b-col cols="8" md="6" lg="4" class="mb-md-0">
            <b-form-group label-cols="auto" label="分类名称" style="margin-bottom: 0;">
              <b-form-input v-model="searchParams.name" class="d-inline-block" placeholder="数据组名称" />
            </b-form-group>
          </b-col>
          <b-col class="d-flex justify-content-end">
            <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="primary" @click="editClick(0)">
              <feather-icon icon="PlusIcon" class="mr-50" />
              <span class="align-middle">数据组</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card>
      <vxe-table
        ref="xTable" border :column-config="{resizable: true}" :auto-resize="true"
        :data="tableData" keep-source highlight-current-row :loading="loading"
        :scroll-x="{enabled: true}" :scroll-y="{enabled: true}"
      >
        <vxe-table-column field="id" title="数据组ID" width="100" align="center"></vxe-table-column>
        <vxe-table-column field="name" title="数据名称" min-width="150" show-overflow></vxe-table-column>
        <vxe-table-column field="configName" title="关键字" min-width="150" show-overflow></vxe-table-column>
        <vxe-table-column field="info" title="数据描述" min-width="250" show-overflow></vxe-table-column>
        <vxe-table-column field="action" title="操作" align="center" fixed="right" width="130" class-name="vxe-table-padding">
          <template v-slot="{ row }">
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'" @click="goDataList(row.id)"
              variant="flat-primary" class="btn-icon" size="sm"
            >
              <feather-icon icon="ListIcon" class="cursor-pointer text-body" size="16" />
            </b-button>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'" @click="editClick(row)"
              variant="flat-primary" class="btn-icon" size="sm"
            >
              <feather-icon icon="EditIcon" class="cursor-pointer text-body" size="16" />
            </b-button>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'" @click="deleteGroup(row.id)"
              variant="flat-primary" class="btn-icon" size="sm"
            >
              <feather-icon icon="Trash2Icon" class="cursor-pointer text-body" size="16" />
            </b-button>
          </template>
        </vxe-table-column>
      </vxe-table>
    </b-card>

    <!-- 编辑信息 -->
    <GroupListEdit :info="infoValue" v-model="showEditModal" @up-ok="upDateGroup" />
  </div>
</template>

<script>
import { ref, watch, onMounted } from '@vue/composition-api'
import router from '@/router'
import Ripple from 'vue-ripple-directive'
import { groupList, groupDelete, groupSave } from '@/api/system/combined.js'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import GroupListEdit from './GroupListEdit.vue'

export default {
  directives: {
    Ripple,
  },
  components: {
    GroupListEdit,
  },
  setup(props, context) {
    /* 必要组件加载区域 */

    // 权限组件 弹出确认组件
    const { $swal } = context.root
    // 消息提醒组件
    const toast = useToast()

    /* 组件页面数据准备区域，包括表单，下拉选择项，数据整理操作等 */
    // 表格加载控制 表格数据
    const loading = ref(false)
    // 列表数据
    const tableData = ref([])
    // 表格对象DOM
    const xTable = ref(null)
    // 查询条件
    const searchParams = ref({ name: '', })
    // 编辑窗口状态
    const showEditModal = ref(false)
    // 待编辑的数据
    const infoValue = ref({
      configName: '',
      id: 0,
      name: '',
      fieldsObjArray: [{ name: '', title: '', param: '[]', type: 'input' }],
      info: '',
      tableConfig: ''
    })

    /* 接口调用区域 方法处理 */
    // 编辑点击处理（来源 0 新增，row 有值来源为行编辑）
    const editClick = row => {
      if (row) {
        // 赋值对应的配置数据
        infoValue.value = JSON.parse(JSON.stringify(row))
      } else {
        // 修改编辑对话框组件的管理属性为初始状态
        infoValue.value = {
          configName: '',
          id: 0, name: '',
          fieldsObjArray: [{ name: '', title: '', param: '[]', type: 'input' }],
          info: '',
          tableConfig: ''
        }
      }
      showEditModal.value = true
    }

    // 跳转数据组中的数据管理
    const goDataList = id => { router.push({ name: 'group-data', params: { id: id }}) }

    // 获取列表
    const fetchData = () => {
      groupList(searchParams.value)
        .then(res => { tableData.value = res.data })
        .catch(err => {
          toast({
            component: ToastificationContent,
            props: { title: '获取数据组失败', text: err.msg, icon: 'AlertTriangleIcon', variant: 'danger' },
          })
        })
    }

    // 删除配置分类
    const deleteGroup = id => {
      $swal({
        title: '删除数据组',
        text: '您正在删除数据组,某些数据组被删除后系统将无法正常运行,请谨慎操作!',
        icon: 'error',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          groupDelete({ id })
            .then(() => {
              fetchData()
              toast({
                component: ToastificationContent,
                props: { title: '数据组状态删除成功', icon: 'CheckCircleIcon', variant: 'success' },
              })
            })
            .catch(err => {
              toast({
                component: ToastificationContent,
                props: { title: '数据组状态删除失败', text: err.msg, icon: 'AlertTriangleIcon', variant: 'danger' },
              })
            })
        }
      })
    }

    // 更新操作
    const upDateGroup = data => {
      groupSave(data)
        .then(() => {
          fetchData()
          toast({
            component: ToastificationContent,
            props: { title: '数据组更新成功', icon: 'CheckCircleIcon', variant: 'success' },
          })
        })
        .catch(err => {
          toast({
            component: ToastificationContent,
            props: { title: '数据组更新失败', text: err.msg, icon: 'AlertTriangleIcon', variant: 'danger' },
          })
        })
    }

    /* 组件内部逻辑处理，生命周期问题处理区域 */

    // 处理基本下拉信息加载，权限判断等
    onMounted(() => { fetchData() })
    // 刷新查询
    watch(searchParams.value, () => { fetchData() })

    return {
      loading,
      tableData,
      xTable,

      showEditModal,
      infoValue,
      editClick,
      goDataList,

      searchParams,
      fetchData,
      deleteGroup,
      upDateGroup,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
